import { parseDate, UI_DATE_FORMAT_STRING } from 'app/ui_v2/helpers/parseDate';
import StarIcon from 'app/ui_v2/icons/StarIcon';

import { Box, useTheme } from '@mui/material';

export interface ProfileInfoProps {
  data: any;
}

export default function ProfileInfo(props: ProfileInfoProps) {
  const { data } = props;

  const theme = useTheme();

  const rating = Math.round(data.averageRating * 10) / 10;

  return (
    <Box my={2} sx={{ display: 'flex', gap: 4 }}>
      <Box>
        <Box display="flex" alignItems="center" mb={0.5}>
          <StarIcon />
          <Box sx={{ fontSize: '1.6rem', ml: 1 }}>
            <strong>{rating || 'N/A'}</strong> ({data.numberOfReviews || 0} Reviews)
          </Box>
        </Box>
      </Box>
      <Box sx={{ borderLeft: `1px solid ${theme.palette.divider}`, pl: 4 }}>
        {/* <Box display="flex" alignItems="center" mb={0.5}>
          <Box sx={{ fontSize: '1.6rem' }}>
            Agency Health Score: <strong>4,2</strong> (347 Reviews)
          </Box>
        </Box> */}
        <Box>
          Last updated at: <strong>{parseDate(data.updatedAt, UI_DATE_FORMAT_STRING)}</strong>
        </Box>
      </Box>
    </Box>
  );
}
